<template>
<div class="modal fade" id="modalChangeGps" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Alteração da Precisão do GPS.</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group owner-select">
            <label>Precisão</label>
            <select v-model="gpsPrecision" id="owner" name="owner" required>
              <option value="">Selecione</option>
              <option v-for="v in listGps" v-bind:value="v.id">{{v.text}}</option>
            </select>
            <span v-if="errorMsg.gps" class="error-msg">{{errorMsg.gps}}</span>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="changeGpsPrecision()" :disabled="loadingChangeModal" v-bind:class="{'disable': loadingChangeModal}" type="submit" class="btn btn-register">
          <span v-if="!loadingChangeModal">Salvar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  ATT_GPS_PRECISION
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../utils";
import swal from "sweetalert";

export default {
  name: "modalChangeGps",
  props: ['dataCompanyModal'],
  data() {
    return {
      modalContext: '',
      companyValue: '',
      listGps: [],
      gpsPrecision: '',
      errorMsg: {
        gps: ''
      },
      loadingChangeModal: false
    }
  },
  watch: {
    dataCompanyModal: function (val) {
      this.companyValue = val;
      this.modalContext = val.context;
    },
  },
  methods: {
    getListGps() {
      this.listGps.push({
        text: 'Default',
        id: 0
      });
      this.listGps.push({
        text: 'Muito Baixo',
        id: 1
      });
      this.listGps.push({
        text: 'Baixo',
        id: 2
      });
      this.listGps.push({
        text: 'Padrão',
        id: 3
      });
      this.listGps.push({
        text: 'Preciso',
        id: 4
      });
      this.listGps.push({
        text: 'Maior Precisão',
        id: 5
      });
    },
    closeModal() {
      $('#modalChangeGps').modal('toggle');
    },
    changeGpsPrecision() {
      this.errorMsg.gps = "";
      if (!this.loadingChangeModal && this.gpsPrecision) {

        this.loadingChangeModal = true;
        UTIL_SERVICE.console("DATA SEND:", this.gpsPrecision);
        REQUEST_SERVICE.get(ATT_GPS_PRECISION + "?companyId=" + this.$route.params.idCompany + "&value=" + this.gpsPrecision).then((response) => {
          UTIL_SERVICE.console("RESULT ATT_GPS_PRECISION:", response);
          this.loadingChangeModal = false;

          $('#modalChangeGps').modal('toggle');

          swal("Aviso", "Empresa atualizada com sucesso.", "success");
        }).catch((reason) => {
          this.loadingChangeModal = false;
          $('#modalChangeGps').modal('toggle');

          swal("Aviso", "Entre em contato com a equipe de DEV.", "error");
        });
      } else {
        this.errorMsg.gps = "Preencha um email válido.";
      }
    }
  },
  mounted() {
    this.getListGps();
  }
}
</script>

<style lang="scss">
#modalChangeGps {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeGPS.vue